import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";

/**
 * The "PRO" tier marker. Single source of truth for the badge that flags
 * PRO-only features across the app — previously this markup was copy-pasted
 * into each call site.
 *
 * Note this is a *signal*, not a gate: it marks a feature as belonging to the
 * PRO tier. Enforcement lives with the feature (e.g. layers are free to add
 * and preview, but `canExportWithLayers` requires PRO to export).
 */
export const ProBadge = ({ className }: { className?: string }) => (
  <Badge
    variant="outline"
    className={cn(
      "text-xs bg-primary/10 text-primary border-primary/30",
      className,
    )}
  >
    PRO
  </Badge>
);

export default ProBadge;
